import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CmsItem, DefaultColorPickerValues } from '@coin/shared/cms/util';
import { V2CheckboxComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { EmailSliderComponent } from '../../shared/email-slider/email-slider.component';

@Component({
  selector: 'coin-email-button',
  templateUrl: './email-button.component.html',
  styleUrls: ['./email-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2CheckboxComponent,
    EmailSliderComponent,
    LegacyComponentsModule,
    FormsModule,
    MatFormFieldModule,
    TranslateModule,
    NgClass,
    V2TextInputComponent
  ]
})
export class EmailButtonComponent implements OnInit {
  @Input() item: CmsItem<'email-button'>;
  @Input() contentEdit = false;
  @Input() showBackgroundPicker = false;

  ngOnInit(): void {
    this.item ??= {} as CmsItem<'email-button'>;
    this.item.content ??= {} as never;
    this.setDefaultBackgroundColor();
  }

  private setDefaultBackgroundColor(): void {
    this.item.backgroundColor = this.item.backgroundColor || DefaultColorPickerValues.backgroundColor;
  }
}
